// extracted by mini-css-extract-plugin
export default {"card":"medicationRecordTab_card__u9CWQ","cardActionSheetRoot":"medicationRecordTab_cardActionSheetRoot__64Spz"};